import Vue from 'vue'
import Router from 'vue-router'
import Gmbch from '@/components/GmbchMain'
import AboutUs from '@/components/AboutUs'
import Contacts from '@/components/Contacts'
import Calendar from '@/components/Calendar'
import Newsletters from '@/components/Newsletters'
import Registration from '@/components/Registration'
import Rules from '@/components/Rules'
import Links from '@/components/Links'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'GmbchRoot',
      component: Gmbch
    },
    {
      path: '/home',
      name: 'Gmbch',
      component: Gmbch
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: AboutUs
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: Calendar
    },
    {
      path: '/newsletters',
      name: 'Newsletters',
      component: Newsletters
    },
    {
      path: '/registration',
      name: 'Registration',
      component: Registration
    },
    {
      path: '/rules',
      name: 'Rules',
      component: Rules
    },
    {
      path: '/links',
      name: 'Links',
      component: Links
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js